/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import {FontWeight} from 'components/Text';
import Label from 'components/Form/Label';
import {mediaHelper} from "../../utils/src";

export const Content = styled.div`
  padding: 10px 0 0;
`;

export const Text = styled.p`
  display: block;
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 5px;
  
  ${mediaHelper.sm`
    font-size: 16px;
  `}
`;

export const Label1 = styled(Label)`
  display: block;
  color: ${Colors.GRAY[2]};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  
  ${mediaHelper.sm`
    font-size: 14px;
  `}
`;
